export default {
    inheritAttrs: false,
    props: {
        content: {
            required: true,
            type: Object,
        },
    },
}
